import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { ScaleFromNumber } from './scale-from-number';

@Pipe({ name: 'currencyScale' })
export class CurrencyScale implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe, private scaleFromNumberPipe: ScaleFromNumber) {}

  public transform(
    value: number,
    currencyPipeCode: string,
    currencyPipeDisplay: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    scalePipeDigitsInfo = '',
    locale = '',
  ): string {
    const sampleNumber: number = 1;
    // To get the currency
    const currencyString: string = this.currencyPipe.transform(
      sampleNumber,
      currencyPipeCode,
      currencyPipeDisplay,
      '1.0-0',
      locale,
    );
    // To get the scaled number
    const scaledString: string = this.scaleFromNumberPipe.transform(value, scalePipeDigitsInfo, locale);
    // Combining currency with scaled number
    return currencyString.replace(String(sampleNumber), scaledString);
  }
}
